import { Button, ButtonArrange, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ReactNode } from 'react';
import styled from 'styled-components';
import type { IllustrationType } from './illustration/mod';
import { Illustration } from './illustration/mod';
import { Title } from './title.component';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		max-width: 100%;
		height: auto;
	`,
};

interface Props {
	title: string;
	description?: ReactNode;
	illustration?: IllustrationType;
	callToAction?: string;
	callToActionCallback?: () => void;
	content?: ReactNode;
}

export function IllustrativeView({ title, description, illustration, callToAction, callToActionCallback, content }: Props) {
	return (
		<Flex gap={tokens.spacing.x4} grow={1} align='center'>
			<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
				{illustration ? <elements.illustration type={illustration} /> : null}
				<Title title={title} titleSize='small' description={description ?? undefined} />
			</elements.container>
			{content}
			{callToAction ? (
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={callToActionCallback}>
							{callToAction}
						</Button>
					</ButtonArrange>
				</Flex>
			) : null}
		</Flex>
	);
}
